import ResponsiveAdSection from "../../../../Components/ResponsiveAdSection/ResponsiveAdSection";

function HomeAdSection(props) {
    return <ResponsiveAdSection {...props} />;
}

export default HomeAdSection;
